"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _MdClose = require("@react-icons/all-files/md/MdClose");

var _MdExpandMore = require("@react-icons/all-files/md/MdExpandMore");

var _nanoid = require("nanoid");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _AccordionWorkflow = _interopRequireDefault(require("../AccordionWorkflow.context"));

var _AccordionWorkflowItem = require("./AccordionWorkflowItem.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AccordionWorkflowItem = function AccordionWorkflowItem(props) {
  var _accordionItemRef$cur;

  var children = props.children,
      expanded = props.expanded,
      theme = props.theme,
      title = props.title,
      onToggle = props.onToggle,
      showAlternateHeader = props.showAlternateHeader;
  var itemId = (0, _react.useMemo)(function () {
    return (0, _nanoid.nanoid)();
  }, []);
  var accordionItemRef = (0, _react.useRef)(null);
  var context = (0, _react.useContext)(_AccordionWorkflow["default"]);

  if (!context) {
    throw new Error('<AccordionWorkflowItem /> must be a child of <Accordion />');
  }

  var type = context.type;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      icon = _useState2[0],
      setIcon = _useState2[1];

  var _useState3 = (0, _react.useState)(itemId),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      accordionId = _useState4[0],
      setAccordionId = _useState4[1];

  var acordionItemWrapper = accordionItemRef === null || accordionItemRef === void 0 ? void 0 : (_accordionItemRef$cur = accordionItemRef.current) === null || _accordionItemRef$cur === void 0 ? void 0 : _accordionItemRef$cur.nextElementSibling;
  var accordionItemContentObject = acordionItemWrapper === null || acordionItemWrapper === void 0 ? void 0 : acordionItemWrapper.nextElementSibling;

  var _useState5 = (0, _react.useState)(400),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      elementHeight = _useState6[0],
      setElementHeight = _useState6[1];

  var _useState7 = (0, _react.useState)(400),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      accordionItemOverflow = _useState8[0],
      setAccordionItemOverflow = _useState8[1];

  var measuredRef = (0, _react.useCallback)(function (rNode) {
    if (rNode) {
      setElementHeight(rNode.scrollHeight);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (accordionItemContentObject) {
      var observer = new MutationObserver(function () {
        setElementHeight(accordionItemContentObject.scrollHeight);
      });
      observer.observe(accordionItemContentObject, {
        attributes: true,
        childList: true,
        characterData: false,
        subtree: true
      });
    }
  }, [accordionItemContentObject]);
  var toggleIcon = theme.accordion.item.title.toggle.icon;

  var setContentVisibility = function setContentVisibility(e) {
    var target = e.target;

    if (target.checked) {
      measuredRef(accordionItemContentObject);
      setTimeout(function () {
        setAccordionItemOverflow('visible');
      }, 1000);
    } else {
      setAccordionItemOverflow('hidden');
    }

    if (onToggle && accordionId === itemId) {
      onToggle(target.checked);
    }
  };

  (0, _react.useEffect)(function () {
    var icons = {
      MdClose: _MdClose.MdClose,
      MdExpandMore: _MdExpandMore.MdExpandMore
    };
    setIcon(icons[toggleIcon]);
  }, [itemId, toggleIcon, theme, expanded, measuredRef, accordionItemContentObject]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AccordionWorkflowItem.StyledAccordionToggle, {
    accordionItemOverflow: accordionItemOverflow,
    checked: expanded,
    elementHeight: elementHeight,
    id: itemId,
    type: "checkbox",
    ref: accordionItemRef,
    className: "accordion-toggle",
    onClick: setContentVisibility,
    onChange: function onChange() {
      return setAccordionId(itemId);
    },
    showAlternateHeader: showAlternateHeader
  }), /*#__PURE__*/_react["default"].createElement(_AccordionWorkflowItem.StyledAccordionItemTitle, (0, _extends2["default"])({
    type: type,
    showAlternateHeader: showAlternateHeader
  }, props), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: itemId
  }, icon && /*#__PURE__*/_react["default"].createElement("div", null, icon), typeof title === 'string' ? /*#__PURE__*/_react["default"].createElement("span", null, title) : title)), /*#__PURE__*/_react["default"].createElement(_AccordionWorkflowItem.StyledAccordionItemContent, {
    ref: measuredRef
  }, /*#__PURE__*/_react["default"].createElement("div", null, children)));
};

AccordionWorkflowItem.defaultProps = {
  expanded: false,
  onToggle: null,
  showAlternateHeader: false
};
AccordionWorkflowItem.propTypes = {
  /** Accordion item content. */
  children: _propTypes.node.isRequired,

  /** Determines if the accordion item should be initially expanded. */
  expanded: _propTypes.bool,

  /** Theme object. Passed automatically by the ThemeProvider high-order component. */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** Title of the accordion item.
   * node: a component either react or html element, will be rendered as is
   * string: string would render in a span */
  title: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]).isRequired,

  /** A callback function that can be passed in to trigger actions in your code if special behavior is needed. */
  onToggle: _propTypes.func,

  /** Allows you to specify if alternate header style should be applied or not. */
  showAlternateHeader: _propTypes.bool
};
AccordionWorkflowItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AccordionWorkflowItem",
  "props": {
    "expanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Determines if the accordion item should be initially expanded.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onToggle": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "A callback function that can be passed in to trigger actions in your code if special behavior is needed.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "showAlternateHeader": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Allows you to specify if alternate header style should be applied or not.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "description": "Accordion item content.",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component.",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "title": {
      "description": "Title of the accordion item.\r\nnode: a component either react or html element, will be rendered as is\r\nstring: string would render in a span",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(AccordionWorkflowItem);

exports["default"] = _default;